export default class UtilsFinanciar {


    bilantMicroStruct_2020 = [
        {
            jsId:'1',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'A. ACTIVE IMOBILIZATE',
            searchText:'A. ACTIVE IMOBILIZATE',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'2',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I.  IMOBILIZĂRI  NECORPORALE  (ct.201+203+205+206+2071+4094+208-280-290)',
            searchText:'I.  IMOBILIZĂRI  NECORPORALE  (ct.201+203+205+206+2071+4094+208-280-290)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'3',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'II.   IMOBILIZĂRI   CORPORALE(ct.211+212+213+214+215+216+217+223+224+227+231+235+4093-281-291-2931-2935)',
            searchText:'II.   IMOBILIZĂRI   CORPORALE(ct.211+212+213+214+215+216+217+223+224+227+231+235+4093-281-291-2931-2935)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'4',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'III. IMOBILIZĂRI FINANCIARE (ct.261+262+263+265+266+267* - 296* )',
            searchText:'III. IMOBILIZĂRI FINANCIARE (ct.261+262+263+265+266+267* - 296* )',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'5',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'ACTIVE IMOBILIZATE - TOTAL (rd. 01 + 02 + 03)',
            searchText:'ACTIVE IMOBILIZATE - TOTAL (rd. 01 + 02 + 03)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

       


        {
            jsId:'6',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'B. ACTIVE CIRCULANTE',
            searchText:'B. ACTIVE CIRCULANTE',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'7',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I.   STOCURI   (ct.301+302+303+321+322+/-308+323+326+327+328+331+332+341+345+346+347+/-348+351+354+356+357+358+361+/-368+371+/-378+381+/-388+4091- 391- 392-393-394-395-396-397-398 - din ct.4428)',
            searchText:'I.   STOCURI   (ct.301+302+303+321+322+/-308+323+326+327+328+331+332+341+345+346+347+/-348+351+354+356+357+358+361+/-368+371+/-378+381+/-388+4091- 391- 392-393-394-395-396-397-398 - din ct.4428)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        },

        {
            jsId:'8',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'II.CREANŢE (Sumele care urmează să fie încasate după o perioadă mai mare de un an trebuie prezentate separat pentru fiecare element)(ct.267*-296*+4092+411+413+418+425+4282+431**+437**+4382+441**+4424+din ct.4428**+444**+445+446**+447**+4482+451**+453**+456**+4582+461+4662+473** - 491 - 495 - 496+5187)',
            searchText:'II.CREANŢE (Sumele care urmează să fie încasate după o perioadă mai mare de un an trebuie prezentate separat pentru fiecare element)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'9',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Creanțe reprezentând dividende repartizate în cursul exercițiului financiar (ct. 463)',
            searchText:'2. Creanțe reprezentând dividende repartizate în cursul exercițiului financiar (ct. 463)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'10',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'TOTAL (rd. 06a+06b',
            searchText:'TOTAL (rd. 06a+06b',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'11',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'III. INVESTIŢII PE TERMEN SCURT(ct.501+505+506+507+din   ct.508+5113+5114-591-595-596-598)',
            searchText:'III. INVESTIŢII PE TERMEN SCURT(ct.501+505+506+507+din   ct.508+5113+5114-591-595-596-598)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'12',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'IV. CASA ŞI CONTURI LA BĂNCI (din ct. 508 + ct. 5112+512+531+532+541+542)',
            searchText:'IV. CASA ŞI CONTURI LA BĂNCI (din ct. 508 + ct. 5112+512+531+532+541+542)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'13',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'ACTIVE CIRCULANTE - TOTAL (rd. 05 + 06 + 07 + 08)',
            searchText:'ACTIVE CIRCULANTE - TOTAL (rd. 05 + 06 + 07 + 08)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'14',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'C. CHELTUIELI ÎN AVANS (ct. 471) (rd.11+12)',
            searchText:'C. CHELTUIELI ÎN AVANS (ct. 471) (rd.11+12)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'15',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă de până la un an (din ct. 471*)',
            searchText:'Sume de reluat într-o perioadă de până la un an (din ct. 471*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'16',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă mai mare de un an (din ct. 471*)',
            searchText:'Sume de reluat într-o perioadă mai mare de un an (din ct. 471*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'17',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'D. DATORII: SUMELE CARE TREBUIE PLĂTITE ÎNTR-O PERIOADĂ DE PÂNĂ LA UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+457+4581+462+4661+473***+509+5186+519)',
            searchText:'D. DATORII: SUMELE CARE TREBUIE PLĂTITE ÎNTR-O PERIOADĂ DE PÂNĂ LA UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+457+4581+462+4661+473***+509+5186+519)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'18',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'E. ACTIVE CIRCULANTE NETE/DATORII CURENTE NETE (rd.09+11-13-20-23-26)',
            searchText:'E. ACTIVE CIRCULANTE NETE/DATORII CURENTE NETE (rd.09+11-13-20-23-26)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'19',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'F. TOTAL ACTIVE MINUS DATORII CURENTE (rd.04 +12+14)',
            searchText:'F. TOTAL ACTIVE MINUS DATORII CURENTE (rd.04 +12+14)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'20',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'G. DATORII:SUMELE CARE TREBUIE PLATITE INTR-O PERIOADA MAI MARE DE UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+4581+462+4661+473***+509+5186+519)',
            searchText:'G. DATORII:SUMELE CARE TREBUIE PLATITE INTR-O PERIOADA MAI MARE DE UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+4581+462+4661+473***+509+5186+519)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'21',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'H. PROVIZIOANE (ct. 151)',
            searchText:'H. PROVIZIOANE (ct. 151)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'22',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I. VENITURI IN AVANS (rd. 19 + 22 + 25 + 28)',
            searchText:'I. VENITURI IN AVANS (rd. 19 + 22 + 25 + 28)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'23',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Subvenţii pentru investiţii (ct. 475), (rd.20+21)',
            searchText:'1. Subvenţii pentru investiţii (ct. 475), (rd.20+21)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'24',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă de până la un an (din ct. 475*)',
            searchText:'Sume de reluat într-o perioadă de până la un an (din ct. 475*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'25',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă mai mare de un an (din ct. 475*)',
            searchText:'Sume de reluat într-o perioadă mai mare de un an (din ct. 475*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'26',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Venituri înregistrate în avans (ct. 472) (rd.23+24)',
            searchText:'2. Venituri înregistrate în avans (ct. 472) (rd.23+24)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'27',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat intr-o perioada de pana la un an (ct. 472*)',
            searchText:'Sume de reluat intr-o perioada de pana la un an (ct. 472*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'28',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat intr-o perioada mai mare de un an (ct. 472*)',
            searchText:'Sume de reluat intr-o perioada mai mare de un an (ct. 472*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'29',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3. Venituri în avans aferente activelor primite prin transfer de la clienţi (ct. 478)(rd.26+27)',
            searchText:'3. Venituri în avans aferente activelor primite prin transfer de la clienţi (ct. 478)(rd.26+27)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'30',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă de până la un an (din ct. 478*)',
            searchText:'Sume de reluat într-o perioadă de până la un an (din ct. 478*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'31',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă mai mare de un an (din ct. 478*)',
            searchText:'Sume de reluat într-o perioadă mai mare de un an (din ct. 478*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'32',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Fondul comercial negativ (ct.2075)',
            searchText:'Fondul comercial negativ (ct.2075)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'33',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'J. CAPITAL ŞI REZERVE',
            searchText:'J. CAPITAL ŞI REZERVE',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'34',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I. CAPITAL (rd. 30+31+32+33+34)',
            searchText:'I. CAPITAL (rd. 30+31+32+33+34)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'35',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Capital subscris vărsat (ct. 1012)',
            searchText:'1. Capital subscris vărsat (ct. 1012)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'36',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Capital subscris nevărsat (ct. 1011)',
            searchText:'2. Capital subscris nevărsat (ct. 1011)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'37',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3. Patrimoniul regiei (ct. 1015)',
            searchText:'3. Patrimoniul regiei (ct. 1015)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'38',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'4. Patrimoniul institutelor naţionale de cercetare-dezvoltare (ct. 1018)',
            searchText:'4. Patrimoniul institutelor naţionale de cercetare-dezvoltare (ct. 1018)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'39',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'5. Alte elemente de capitaluri proprii (ct. 1031)',
            searchText:'5. Alte elemente de capitaluri proprii (ct. 1031)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'40',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'II. PRIME DE CAPITAL (ct. 104)',
            searchText:'II. PRIME DE CAPITAL (ct. 104)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'41',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'III. REZERVE DIN REEVALUARE (ct. 105)',
            searchText:'III. REZERVE DIN REEVALUARE (ct. 105)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'42',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'IV. REZERVE (ct.106)',
            searchText:'IV. REZERVE (ct.106)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'43',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Acţiuni proprii (ct. 109)',
            searchText:'Acţiuni proprii (ct. 109)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'44',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Câştiguri legate de instrumentele de capitaluri proprii (ct. 141)',
            searchText:'Câştiguri legate de instrumentele de capitaluri proprii (ct. 141)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'45',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Pierderi legate de instrumentele  de capitaluri proprii (ct. 149)',
            searchText:'Pierderi legate de instrumentele  de capitaluri proprii (ct. 149)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'46',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'V. PROFITUL SAU PIERDEREA REPORTAT(Ă)                   SOLD C (ct. 117)',
            searchText:'V. PROFITUL SAU PIERDEREA REPORTAT(Ă)                   SOLD C (ct. 117)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'47',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'SOLD D (ct. 117',
            searchText:'SOLD D (ct. 117',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'48',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VI. PROFITUL SAU PIERDEREA EXERCIŢIULUI FINANCIAR',
            searchText:'VI. PROFITUL SAU PIERDEREA EXERCIŢIULUI FINANCIAR',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'49',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'SOLD C (ct. 121)',
            searchText:'SOLD C (ct. 121)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'50',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'SOLD D (ct. 121)',
            searchText:'SOLD D (ct. 121)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'51',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Repartizarea profitului (ct. 129)',
            searchText:'Repartizarea profitului (ct. 129)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'52',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CAPITALURI PROPRII - TOTAL (rd. 29+35+36+37-38+39-40+41-42+43-44-45)',
            searchText:'CAPITALURI PROPRII - TOTAL (rd. 29+35+36+37-38+39-40+41-42+43-44-45)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'53',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Patrimoniul public (ct. 1016)',
            searchText:'Patrimoniul public (ct. 1016)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'54',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Patrimoniul privat (ct. 1017)',
            searchText:'Patrimoniul privat (ct. 1017)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'55',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CAPITALURI - TOTAL (rd. 46+47+48) (rd.04+09+10-13-16-17-18)',
            searchText:'CAPITALURI - TOTAL (rd. 46+47+48) (rd.04+09+10-13-16-17-18)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'56',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Cifra de afaceri netă (ct.701 + 702 + 703 + 704 + 705 + 706 + 708 + 707 - 709 + 741** + 766***)',
            searchText:'1. Cifra de afaceri netă (ct.701 + 702 + 703 + 704 + 705 + 706 + 708 + 707 - 709 + 741** + 766***)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'57',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Alte venituri (ct.711 + 712 + 721 + 722 + 725 + 741**** + 751 + 755 + 758 + 761 + 762 + 764 + 765 + 766 + 767 + 768 + 7815)',
            searchText:'2. Alte venituri (ct.711 + 712 + 721 + 722 + 725 + 741**** + 751 + 755 + 758 + 761 + 762 + 764 + 765 + 766 + 767 + 768 + 7815)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'58',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3. Costul materiilor prime și al consumabilelor (ct. 601 + 602 - 609*)',
            searchText:'3. Costul materiilor prime și al consumabilelor (ct. 601 + 602 - 609*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'59',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'4. Cheltuieli cu personalul (ct. 641 + 642 + 643 + 644 + 645)',
            searchText:'4. Cheltuieli cu personalul (ct. 641 + 642 + 643 + 644 + 645)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'60',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'5. Ajustări de valoare (ct. 654 + 681 + 686 - 754 - 7812 - 7813 - 7814 - 786)',
            searchText:'5. Ajustări de valoare (ct. 654 + 681 + 686 - 754 - 7812 - 7813 - 7814 - 786)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'61',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'6. Alte cheltuieli*****  (ct. 603 + 604 + 605 + 606 + 607 + 608 - 609* + 611 + 612 + 613 + 614 + 615 + 621 + 622 + 623 + 624 + 625 + 626 + 627 + 628 + 635 + 651 + 652+ 655+ 658 + 663 + 664 + 665 + 667 + 666+ 668)',
            searchText:'6. Alte cheltuieli*****  (ct. 603 + 604 + 605 + 606 + 607 + 608 - 609* + 611 + 612 + 613 + 614 + 615 + 621 + 622 + 623 + 624 + 625 + 626 + 627 + 628 + 635 + 651 + 652+ 655+ 658 + 663 + 664 + 665 + 667 + 666+ 668)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'62',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'7. Impozite (ct.691 + 698)',
            searchText:'7. Impozite (ct.691 + 698)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'63',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'8.  PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            searchText:'8.  PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'64',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd.01+02-03-04-05-06-07)',
            searchText:'- Profit (rd.01+02-03-04-05-06-07)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'65',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd.03+04+05+06+07-01-02)',
            searchText:'- Pierdere (rd.03+04+05+06+07-01-02)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'66',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe comerciale, avansuri pentru cumpărări de bunuri de natura stocurilor și pentru prestări de servicii acordate furnizorilor şi alte conturi asimilate, în sume brute (ct. 4091 + 4092 + 411 + 413 + 418), din care:',
            searchText:'Creanţe comerciale, avansuri pentru cumpărări de bunuri de natura stocurilor și pentru prestări de servicii acordate furnizorilor şi alte conturi asimilate, în sume brute (ct. 4091 + 4092 + 411 + 413 + 418), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'67',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe neîncasate la termenul stabilit (din ct. 4091 + din ct. 4092 + din ct. 411 + din ct. 413)',
            searchText:'Creanţe neîncasate la termenul stabilit (din ct. 4091 + din ct. 4092 + din ct. 411 + din ct. 413)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'68',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe în legătură cu personalul şi conturi asimilate (ct. 425 + 4282)',
            searchText:'Creanţe în legătură cu personalul şi conturi asimilate (ct. 425 + 4282)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'69',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe în legătură cu bugetul asigurărilor sociale şi bugetul statului (din ct. 431 + 437 + 4382 + 441 + 4424 + 4428 + 444 + 445 + 446 + 447 + 4482) , (rd.92 la 96)',
            searchText:'Creanţe în legătură cu bugetul asigurărilor sociale şi bugetul statului (din ct. 431 + 437 + 4382 + 441 + 4424 + 4428 + 444 + 445 + 446 + 447 + 4482) , (rd.92 la 96)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'70',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- creante in legatura cu bugetul asigurarilor sociale (ct.431+437+4382)',
            searchText:'- creante in legatura cu bugetul asigurarilor sociale (ct.431+437+4382)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'71',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- creante fiscale in legatura cu bugetul statului (ct.441+4424+4428+444+446)',
            searchText:'- creante fiscale in legatura cu bugetul statului (ct.441+4424+4428+444+446)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'72',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- subventii de incasat(ct.445)',
            searchText:'- subventii de incasat(ct.445)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'73',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            searchText:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'74',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- alte creante in legatura cu bugetul statului(ct.4482)',
            searchText:'- alte creante in legatura cu bugetul statului(ct.4482)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'75',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creantele entitatii in relatiile cu entitatile afiliate(ct.451)',
            searchText:'Creantele entitatii in relatiile cu entitatile afiliate(ct.451)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'76',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Casa în lei şi în valută (rd.116+117 )',
            searchText:'Casa în lei şi în valută (rd.116+117 )',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'77',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei (ct. 5311)',
            searchText:'- în lei (ct. 5311)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'78',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută (ct. 5314)',
            searchText:'- în valută (ct. 5314)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'79',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Conturi curente la bănci în lei şi în valută (rd.119+121)',
            searchText:'Conturi curente la bănci în lei şi în valută (rd.119+121)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'80',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei (ct. 5121), din care:',
            searchText:'- în lei (ct. 5121), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'81',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- conturi curente în lei deschise la bănci nerezidente',
            searchText:'- conturi curente în lei deschise la bănci nerezidente',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'82',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută (ct. 5124), din care:',
            searchText:'- în valută (ct. 5124), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'83',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- conturi curente în valută deschise la bănci nerezidente',
            searchText:'- conturi curente în valută deschise la bănci nerezidente',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'84',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte conturi curente la bănci şi acreditive, (rd.124+125)',
            searchText:'Alte conturi curente la bănci şi acreditive, (rd.124+125)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'85',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume în curs de decontare, acreditive şi alte valori de încasat, în lei (ct. 5112 + 5125 + 5411)',
            searchText:'- sume în curs de decontare, acreditive şi alte valori de încasat, în lei (ct. 5112 + 5125 + 5411)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'86',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume în curs de decontare şi acreditive în valută (din ct. 5125 + 5414)',
            searchText:'- sume în curs de decontare şi acreditive în valută (din ct. 5125 + 5414)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'87',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii (rd. 127 + 130+ 133 + 136 + 139 + 142 + 145 + 148 + 151+ 154 + 157 + 158 + 161 + 162+ 164 + 165 + 170 + 171 + 172 + 178)',
            searchText:'Datorii (rd. 127 + 130+ 133 + 136 + 139 + 142 + 145 + 148 + 151+ 154 + 157 + 158 + 161 + 162+ 164 + 165 + 170 + 171 + 172 + 178)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'88',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Împrumuturi din emisiuni de obligaţiuni , în sume brute (ct. 161 ),(rd. 128 +129)',
            searchText:'Împrumuturi din emisiuni de obligaţiuni , în sume brute (ct. 161 ),(rd. 128 +129)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'89',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'90',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'91',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente imprumuturilor din emisiuni de obligatiuni in sume brute (ct.1681), (rd.131 +132)',
            searchText:'Dobanzi aferente imprumuturilor din emisiuni de obligatiuni in sume brute (ct.1681), (rd.131 +132)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'92',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'93',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in valuta',
            searchText:'- in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'94',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite bancare interne pe termen scurt  (ct. 5191 + 5192 + 5196 + 5197 ), (rd. 134+135)',
            searchText:'Credite bancare interne pe termen scurt  (ct. 5191 + 5192 + 5196 + 5197 ), (rd. 134+135)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'95',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'96',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'97',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzile aferente creditelor bancare interne pe termen scurt(din ct. 5198), (rd. 137+138)',
            searchText:'Dobanzile aferente creditelor bancare interne pe termen scurt(din ct. 5198), (rd. 137+138)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'98',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'99',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'100',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente creditelor bancare externe pe termen scurt (din ct.5198), ( rd. 143+144)',
            searchText:'Dobanzi aferente creditelor bancare externe pe termen scurt (din ct.5198), ( rd. 143+144)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'101',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'102',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in valuta',
            searchText:'- in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'103',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite bancare pe termen lung  (ct. 1621 + 1622 + 1627 ), (rd.146+147)',
            searchText:'Credite bancare pe termen lung  (ct. 1621 + 1622 + 1627 ), (rd.146+147)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'104',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'105',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'106',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente creditelor bancare pe termen lung (din ct.1682) (rd.149+150)',
            searchText:'Dobanzi aferente creditelor bancare pe termen lung (din ct.1682) (rd.149+150)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'107',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'108',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'-in valuta',
            searchText:'-in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'109',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite bancare externe pe termen lung  (ct. 1623 + 1624 + 1625 ) (rd.152+153)',
            searchText:'Credite bancare externe pe termen lung  (ct. 1623 + 1624 + 1625 ) (rd.152+153)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'110',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'111',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'112',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente creditelor bancare externe pe termen lung ( din ct.1682), (rd. 155+156)',
            searchText:'Dobanzi aferente creditelor bancare externe pe termen lung ( din ct.1682), (rd. 155+156)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'113',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'114',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in valuta',
            searchText:'- in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'115',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite de la trezoreria statului si dobanzile aferente (ct.1626 + din ct. 1682)',
            searchText:'Credite de la trezoreria statului si dobanzile aferente (ct.1626 + din ct. 1682)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'116',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte împrumuturi şi dobânzile aferente (ct. 166  + 1685 + 1686 + 1687) (rd. 159+160)',
            searchText:'Alte împrumuturi şi dobânzile aferente (ct. 166  + 1685 + 1686 + 1687) (rd. 159+160)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'117',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei si exprimate in lei, a caror decontare se face in functie de cursul  unei valute',
            searchText:'- în lei si exprimate in lei, a caror decontare se face in functie de cursul  unei valute',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'118',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'119',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte împrumuturi şi datorii asimilate (ct. 167), din care:',
            searchText:'Alte împrumuturi şi datorii asimilate (ct. 167), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'120',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- valoarea concesiunilor primite (din ct. 167)',
            searchText:'- valoarea concesiunilor primite (din ct. 167)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'121',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii comerciale, avansuri primite de la clienţi şi alte conturi asimilate, în sume brute (ct. 401 + 403 + 404 + 405 + 408 + 419), din care:',
            searchText:'Datorii comerciale, avansuri primite de la clienţi şi alte conturi asimilate, în sume brute (ct. 401 + 403 + 404 + 405 + 408 + 419), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'122',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii în legătură cu personalul şi conturi asimilate (ct. 421 + 423 + 424 + 426 + 427 + 4281)',
            searchText:'Datorii în legătură cu personalul şi conturi asimilate (ct. 421 + 423 + 424 + 426 + 427 + 4281)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'123',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii în legătură cu bugetul asigurărilor sociale şi bugetul statului (ct. 431 + 437 + 4381 + 441 + 4423 + 4428 + 444 + 446 + 447 + 4481) (rd.166 la 169)',
            searchText:'Datorii în legătură cu bugetul asigurărilor sociale şi bugetul statului (ct. 431 + 437 + 4381 + 441 + 4423 + 4428 + 444 + 446 + 447 + 4481) (rd.166 la 169)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'124',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- datorii in legatura cu bugetul asigurarilor sociale (ct.431+437+4381)',
            searchText:'- datorii in legatura cu bugetul asigurarilor sociale (ct.431+437+4381)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'125',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- datorii fiscale in legatura cu bugetul statului (ct.441+4423+4428+444+446)',
            searchText:'- datorii fiscale in legatura cu bugetul statului (ct.441+4423+4428+444+446)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'126',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            searchText:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'127',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- alte datorii in legatura cu bugetul statului (ct.4481)',
            searchText:'- alte datorii in legatura cu bugetul statului (ct.4481)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'128',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datoriile entitatii in relatiile cu entitatile afiliate (ct.451)',
            searchText:'Datoriile entitatii in relatiile cu entitatile afiliate (ct.451)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'129',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume datorate actionarilor / asociatilor (ct.455), din care:',
            searchText:'Sume datorate actionarilor / asociatilor (ct.455), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'130',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume datorate actionarilor / asociatilor PF',
            searchText:'- sume datorate actionarilor / asociatilor PF',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'131',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume datorate actionarilor / asociatilor PJ',
            searchText:'- sume datorate actionarilor / asociatilor PJ',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'132',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte datorii (ct. 269 + 453 + 456 + 457 + 4581 + 4661 + 462 + 472 + 473 + 478 + 509)   (rd.173 la 177)',
            searchText:'Alte datorii (ct. 269 + 453 + 456 + 457 + 4581 + 4661 + 462 + 472 + 473 + 478 + 509)   (rd.173 la 177)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'133',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Cifra de afaceri netă (rd. 222+223-224+225+226)',
            searchText:'1. Cifra de afaceri netă (rd. 222+223-224+225+226)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'134',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Producţia  vândută  (ct.701+702+703+704+705+706+708)',
            searchText:'Producţia  vândută  (ct.701+702+703+704+705+706+708)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'135',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Venituri din vânzarea mărfurilor (ct. 707)',
            searchText:'Venituri din vânzarea mărfurilor (ct. 707)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'136',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Reduceri comerciale acordate (ct. 709)',
            searchText:'Reduceri comerciale acordate (ct. 709)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'137',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Venituri din dobânzi înregistrate de entităţile radiate din Registrul general si care mai au in derulare contracte de leasing  (ct.766) 7)',
            searchText:'Venituri din dobânzi înregistrate de entităţile radiate din Registrul general si care mai au in derulare contracte de leasing  (ct.766) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'138',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Venituri din subvenţii de exploatare aferente cifrei de afaceri nete (ct.7411)',
            searchText:'Venituri din subvenţii de exploatare aferente cifrei de afaceri nete (ct.7411)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'139',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Venituri aferente costului producţiei în curs de execuţie  (ct.711+712)',
            searchText:'2. Venituri aferente costului producţiei în curs de execuţie  (ct.711+712)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'140',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sold C',
            searchText:'Sold C',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'141',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sold D',
            searchText:'Sold D',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'142',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3.  Venituri din producţia de imobilizari necorporale si corporale (ct.721+ 722)',
            searchText:'3.  Venituri din producţia de imobilizari necorporale si corporale (ct.721+ 722)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'143',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'4. Venituri din reevaluarea imobilizărilor corporale (ct. 755)',
            searchText:'4. Venituri din reevaluarea imobilizărilor corporale (ct. 755)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'144',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'5. Venituri din producţia de investiţii imobiliare  (ct. 725)',
            searchText:'5. Venituri din producţia de investiţii imobiliare  (ct. 725)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'145',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'6. Venituri din subvenții de exploatare (ct. 7412 + 7413 + 7414 + 7415 + 7416 + 7417 + 7419)',
            searchText:'6. Venituri din subvenții de exploatare (ct. 7412 + 7413 + 7414 + 7415 + 7416 + 7417 + 7419)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'146',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'7. Alte venituri din exploatare (ct.751+758+7815)',
            searchText:'7. Alte venituri din exploatare (ct.751+758+7815)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'147',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'-din care, venituri din fondul comercial negativ  (ct.7815)',
            searchText:'-din care, venituri din fondul comercial negativ  (ct.7815)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'148',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'-din care, venituri din subvenții pentru investiții (ct. 7584)',
            searchText:'-din care, venituri din subvenții pentru investiții (ct. 7584)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'149',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VENITURI DIN EXPLOATARE – TOTAL (rd. 221 + 227 - 228 + 229 + 230 + 231 + 232 + 233)',
            searchText:'VENITURI DIN EXPLOATARE – TOTAL (rd. 221 + 227 - 228 + 229 + 230 + 231 + 232 + 233)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'150',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'8. a)  Cheltuieli cu materiile prime şi materialele consumabile (ct.601+602)',
            searchText:'8. a)  Cheltuieli cu materiile prime şi materialele consumabile (ct.601+602)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'151',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte cheltuieli materiale (ct.603+604+606+608)',
            searchText:'Alte cheltuieli materiale (ct.603+604+606+608)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'152',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b) Alte cheltuieli externe (cu energie şi apă)(ct.605)',
            searchText:'b) Alte cheltuieli externe (cu energie şi apă)(ct.605)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'153',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'c) Cheltuieli privind mărfurile (ct.607)',
            searchText:'c) Cheltuieli privind mărfurile (ct.607)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'154',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Reduceri comerciale primite (ct. 609)',
            searchText:'Reduceri comerciale primite (ct. 609)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'155',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'9. Cheltuieli cu personalul (rd. 243 + 244)',
            searchText:'9. Cheltuieli cu personalul (rd. 243 + 244)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'156',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'a) Salarii şi indemnizaţii 8) (ct.641+642+643+644)',
            searchText:'a) Salarii şi indemnizaţii 8) (ct.641+642+643+644)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'157',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b) Cheltuieli privind asigurările şi protecţia socială (ct.645)',
            searchText:'b) Cheltuieli privind asigurările şi protecţia socială (ct.645)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'158',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'10.a) Ajustări de valoare privind imobilizările corporale şi necorporale (rd. 246 - 247)',
            searchText:'10.a) Ajustări de valoare privind imobilizările corporale şi necorporale (rd. 246 - 247)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'159',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'a.1) Cheltuiel (ct.6811+6813+6817)',
            searchText:'a.1) Cheltuiel (ct.6811+6813+6817)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'160',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'a.2) Venituri (ct.7813)',
            searchText:'a.2) Venituri (ct.7813)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'161',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b) Ajustări de valoare privind activele circulante (rd. 249 - 250)',
            searchText:'b) Ajustări de valoare privind activele circulante (rd. 249 - 250)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'162',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b.1) Cheltuieli (ct.654+6814)',
            searchText:'b.1) Cheltuieli (ct.654+6814)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'163',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b.2) Venituri (ct.754+7814)',
            searchText:'b.2) Venituri (ct.754+7814)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'164',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11. Alte cheltuieli de exploatare (rd. 252 la 258)',
            searchText:'11. Alte cheltuieli de exploatare (rd. 252 la 258)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'165',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.1. Cheltuieli privind prestaţiile externe (ct.611+612+613+614+615+621+622+623+624+625+626+627+628)',
            searchText:'11.1. Cheltuieli privind prestaţiile externe (ct.611+612+613+614+615+621+622+623+624+625+626+627+628)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'166',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.2. Cheltuieli cu alte impozite, taxe şi vărsăminte asimilate;  cheltuieli reprezentând transferuri şi contribuţii datorate în baza unor acte normative speciale (ct. 635 + 6586 9) )',
            searchText:'11.2. Cheltuieli cu alte impozite, taxe şi vărsăminte asimilate;  cheltuieli reprezentând transferuri şi contribuţii datorate în baza unor acte normative speciale (ct. 635 + 6586 9) )',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'167',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.3. Cheltuieli cu protecţia mediului înconjurător (ct. 652)',
            searchText:'11.3. Cheltuieli cu protecţia mediului înconjurător (ct. 652)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'168',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.4 Cheltuieli din reevaluarea imobilizărilor corporale (ct. 655)',
            searchText:'11.4 Cheltuieli din reevaluarea imobilizărilor corporale (ct. 655)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'169',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.5. Cheltuieli privind calamităţile şi alte evenimente similare (ct. 6587)',
            searchText:'11.5. Cheltuieli privind calamităţile şi alte evenimente similare (ct. 6587)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'170',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.6. Alte cheltuieli (ct. 651 + 6581 + 6582 + 6583 + 6588)',
            searchText:'11.6. Alte cheltuieli (ct. 651 + 6581 + 6582 + 6583 + 6588)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'171',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Cheltuieli cu dobânzile de refinanţare înregistrate de entităţile radiate din Registrul general şi care mai au în derulare contracte de leasing (ct. 666) 7)',
            searchText:'Cheltuieli cu dobânzile de refinanţare înregistrate de entităţile radiate din Registrul general şi care mai au în derulare contracte de leasing (ct. 666) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'172',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Ajustări privind provizioanele (rd. 260 - 261)',
            searchText:'Ajustări privind provizioanele (rd. 260 - 261)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'173',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Cheltuieli (ct.6812)',
            searchText:'- Cheltuieli (ct.6812)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'174',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Venituri (ct.7812)',
            searchText:'- Venituri (ct.7812)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'175',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CHELTUIELI DE EXPLOATARE – TOTAL(rd. 237 la 240 - 241 + 242 + 245 + 248 + 251 + 259)',
            searchText:'CHELTUIELI DE EXPLOATARE – TOTAL(rd. 237 la 240 - 241 + 242 + 245 + 248 + 251 + 259)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'176',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'PROFITUL SAU PIERDEREA DIN EXPLOATARE:',
            searchText:'PROFITUL SAU PIERDEREA DIN EXPLOATARE:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'177',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 236 - 262)',
            searchText:'- Profit (rd. 236 - 262)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'178',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 262 - 236)',
            searchText:'- Pierdere (rd. 262 - 236)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'179',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'12.  Venituri din interese de participare (ct.7611+7612+7613)',
            searchText:'12.  Venituri din interese de participare (ct.7611+7612+7613)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },
        
        {
            jsId:'180',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, veniturile obţinute de la entităţile afiliate',
            searchText:'- din care, veniturile obţinute de la entităţile afiliate',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'181',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'13.  Venituri din dobânzi (ct.766) 7)',
            searchText:'13.  Venituri din dobânzi (ct.766) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'182',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, veniturile obţinute de la entităţile afiliate',
            searchText:'- din care, veniturile obţinute de la entităţile afiliate',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'183',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'14. Venituri din subvenţii de exploatare pentru dobânda datorată  (ct. 7418)',
            searchText:'14. Venituri din subvenţii de exploatare pentru dobânda datorată  (ct. 7418)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'184',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'15. Alte venituri financiare (ct. 7615 + 762 + 764 + 765 + 767 + 768)',
            searchText:'15. Alte venituri financiare (ct. 7615 + 762 + 764 + 765 + 767 + 768)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'185',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, venituri din alte imobilizări financiare    (ct. 7615)',
            searchText:'- din care, venituri din alte imobilizări financiare    (ct. 7615)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'186',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VENITURI FINANCIARE – TOTAL (rd. 265 + 267 + 269 + 270)',
            searchText:'VENITURI FINANCIARE – TOTAL (rd. 265 + 267 + 269 + 270)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'187',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'16.  Ajustări de valoare privind imobilizările financiare şi investiţiile financiare deţinute ca active circulante (rd. 274 - 275)',
            searchText:'16.  Ajustări de valoare privind imobilizările financiare şi investiţiile financiare deţinute ca active circulante (rd. 274 - 275)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'188',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Cheltuieli  (ct.686)',
            searchText:'- Cheltuieli  (ct.686)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'189',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Venituri (ct.786)',
            searchText:'- Venituri (ct.786)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'190',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'17.  Cheltuieli privind dobânzile (ct.666) 7)',
            searchText:'17.  Cheltuieli privind dobânzile (ct.666) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'191',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, cheltuielile în relaţia cu entităţile afiliate',
            searchText:'- din care, cheltuielile în relaţia cu entităţile afiliate',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'192',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte cheltuieli financiare (ct.663+664+665+667+668)',
            searchText:'Alte cheltuieli financiare (ct.663+664+665+667+668)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'193',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CHELTUIELI FINANCIARE – TOTAL (rd. 273+ 276 +278)',
            searchText:'CHELTUIELI FINANCIARE – TOTAL (rd. 273+ 276 +278)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'194',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'PROFITUL SAU PIERDEREA FINANCIAR(Ă):',
            searchText:'PROFITUL SAU PIERDEREA FINANCIAR(Ă):',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'195',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 272 - 279)',
            searchText:'- Profit (rd. 272 - 279)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'196',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 279 - 272)',
            searchText:'- Pierdere (rd. 279 - 272)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'197',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VENITURI TOTALE (rd. 236 + 272)',
            searchText:'VENITURI TOTALE (rd. 236 + 272)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'198',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CHELTUIELI TOTALE (rd. 262 + 279)',
            searchText:'CHELTUIELI TOTALE (rd. 262 + 279)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'199',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'18. PROFITUL SAU PIERDEREA BRUT(Ă):',
            searchText:'18. PROFITUL SAU PIERDEREA BRUT(Ă):',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'200',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 282 - 283)',
            searchText:'- Profit (rd. 282 - 283)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'201',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 283 - 282)',
            searchText:'- Pierdere (rd. 283 - 282)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'202',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'19.  Impozitul pe profit (ct. 691)',
            searchText:'19.  Impozitul pe profit (ct. 691)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'203',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'20.  Alte impozite neprezentate la elementele de mai sus (ct. 698)',
            searchText:'20.  Alte impozite neprezentate la elementele de mai sus (ct. 698)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'204',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'21. PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            searchText:'21. PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'205',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 284 - 285 - 286 - 287)',
            searchText:'- Profit (rd. 284 - 285 - 286 - 287)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'206',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 285 + 286 + 287 - 284)',
            searchText:'- Pierdere (rd. 285 + 286 + 287 - 284)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },
    ]


    bilantMicroStruct_2016 = [


        {
            jsId:'1',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'A. ACTIVE IMOBILIZATE',
            searchText:'A. ACTIVE IMOBILIZATE',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },
        
        {
            jsId:'2',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I.  IMOBILIZĂRI  NECORPORALE  (ct.201+203+205+206+2071+4094+208-280-290)',
            searchText:'I.  IMOBILIZĂRI  NECORPORALE  (ct.201+203+205+206+2071+4094+208-280-290)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'3',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'II.   IMOBILIZĂRI   CORPORALE(ct.211+212+213+214+215+216+217+223+224+227+231+235+4093-281-291-2931-2935)',
            searchText:'II.   IMOBILIZĂRI   CORPORALE(ct.211+212+213+214+215+216+217+223+224+227+231+235+4093-281-291-2931-2935)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'4',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'III. IMOBILIZĂRI FINANCIARE (ct.261+262+263+265+266+267* - 296* )',
            searchText:'III. IMOBILIZĂRI FINANCIARE (ct.261+262+263+265+266+267* - 296* )',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'5',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'ACTIVE IMOBILIZATE - TOTAL (rd. 01 + 02 + 03)',
            searchText:'ACTIVE IMOBILIZATE - TOTAL (rd. 01 + 02 + 03)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'6',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'B. ACTIVE CIRCULANTE',
            searchText:'B. ACTIVE CIRCULANTE',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'7',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I.   STOCURI   (ct.301+302+303+321+322+/-308+323+326+327+328+331+332+341+345+346+347+/-348+351+354+356+357+358+361+/-368+371+/-378+381+/-388+4091- 391- 392-393-394-395-396-397-398 - din ct.4428)',
            searchText:'I.   STOCURI   (ct.301+302+303+321+322+/-308+323+326+327+328+331+332+341+345+346+347+/-348+351+354+356+357+358+361+/-368+371+/-378+381+/-388+4091- 391- 392-393-394-395-396-397-398 - din ct.4428)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        },

        {
            jsId:'8',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'II.CREANŢE (Sumele care urmează să fie încasate după o perioadă mai mare de un an trebuie prezentate separat pentru fiecare element)(ct.267*-296*+4092+411+413+418+425+4282+431**+437**+4382+441**+4424+din ct.4428**+444**+445+446**+447**+4482+451**+453**+456**+4582+461+4662+473** - 491 - 495 - 496+5187)',
            searchText:'II.CREANŢE (Sumele care urmează să fie încasate după o perioadă mai mare de un an trebuie prezentate separat pentru fiecare element)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'9',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'III. INVESTIŢII PE TERMEN SCURT(ct.501+505+506+507+din   ct.508+5113+5114-591-595-596-598)',
            searchText:'III. INVESTIŢII PE TERMEN SCURT(ct.501+505+506+507+din   ct.508+5113+5114-591-595-596-598)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'10',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'IV. CASA ŞI CONTURI LA BĂNCI (din ct. 508 + ct. 5112+512+531+532+541+542)',
            searchText:'IV. CASA ŞI CONTURI LA BĂNCI (din ct. 508 + ct. 5112+512+531+532+541+542)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'11',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'ACTIVE CIRCULANTE - TOTAL (rd. 05 + 06 + 07 + 08)',
            searchText:'ACTIVE CIRCULANTE - TOTAL (rd. 05 + 06 + 07 + 08)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'12',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'C. CHELTUIELI ÎN AVANS (ct. 471) (rd.11+12)',
            searchText:'C. CHELTUIELI ÎN AVANS (ct. 471) (rd.11+12)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'13',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă de până la un an (din ct. 471*)',
            searchText:'Sume de reluat într-o perioadă de până la un an (din ct. 471*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'14',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă mai mare de un an (din ct. 471*)',
            searchText:'Sume de reluat într-o perioadă mai mare de un an (din ct. 471*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'15',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'D. DATORII: SUMELE CARE TREBUIE PLĂTITE ÎNTR-O PERIOADĂ DE PÂNĂ LA UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+457+4581+462+4661+473***+509+5186+519)',
            searchText:'D. DATORII: SUMELE CARE TREBUIE PLĂTITE ÎNTR-O PERIOADĂ DE PÂNĂ LA UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+457+4581+462+4661+473***+509+5186+519)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'16',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'E. ACTIVE CIRCULANTE NETE/DATORII CURENTE NETE (rd.09+11-13-20-23-26)',
            searchText:'E. ACTIVE CIRCULANTE NETE/DATORII CURENTE NETE (rd.09+11-13-20-23-26)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'17',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'F. TOTAL ACTIVE MINUS DATORII CURENTE (rd.04 +12+14)',
            searchText:'F. TOTAL ACTIVE MINUS DATORII CURENTE (rd.04 +12+14)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'18',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'G. DATORII:SUMELE CARE TREBUIE PLATITE INTR-O PERIOADA MAI MARE DE UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+4581+462+4661+473***+509+5186+519)',
            searchText:'G. DATORII:SUMELE CARE TREBUIE PLATITE INTR-O PERIOADA MAI MARE DE UN AN    (ct.161+162+166+167+168-169+269+401+403+404+405+408+419+421+423+424+426+427+4281+431***+437***+4381+441***+4423+4428***+444***+446***+ 447***+4481+451***+453*** +455+456***+4581+462+4661+473***+509+5186+519)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'19',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'H. PROVIZIOANE (ct. 151)',
            searchText:'H. PROVIZIOANE (ct. 151)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'20',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I. VENITURI IN AVANS (rd. 19 + 22 + 25 + 28)',
            searchText:'I. VENITURI IN AVANS (rd. 19 + 22 + 25 + 28)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'21',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Subvenţii pentru investiţii (ct. 475), (rd.20+21)',
            searchText:'1. Subvenţii pentru investiţii (ct. 475), (rd.20+21)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'22',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă de până la un an (din ct. 475*)',
            searchText:'Sume de reluat într-o perioadă de până la un an (din ct. 475*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'23',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă mai mare de un an (din ct. 475*)',
            searchText:'Sume de reluat într-o perioadă mai mare de un an (din ct. 475*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'24',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Venituri înregistrate în avans (ct. 472) (rd.23+24)',
            searchText:'2. Venituri înregistrate în avans (ct. 472) (rd.23+24)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'25',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat intr-o perioada de pana la un an (ct. 472*)',
            searchText:'Sume de reluat intr-o perioada de pana la un an (ct. 472*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'26',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat intr-o perioada mai mare de un an (ct. 472*)',
            searchText:'Sume de reluat intr-o perioada mai mare de un an (ct. 472*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'27',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3. Venituri în avans aferente activelor primite prin transfer de la clienţi (ct. 478)(rd.26+27)',
            searchText:'3. Venituri în avans aferente activelor primite prin transfer de la clienţi (ct. 478)(rd.26+27)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'28',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă de până la un an (din ct. 478*)',
            searchText:'Sume de reluat într-o perioadă de până la un an (din ct. 478*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'29',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume de reluat într-o perioadă mai mare de un an (din ct. 478*)',
            searchText:'Sume de reluat într-o perioadă mai mare de un an (din ct. 478*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'30',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Fondul comercial negativ (ct.2075)',
            searchText:'Fondul comercial negativ (ct.2075)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'31',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'J. CAPITAL ŞI REZERVE',
            searchText:'J. CAPITAL ŞI REZERVE',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'32',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'I. CAPITAL (rd. 30+31+32+33+34)',
            searchText:'I. CAPITAL (rd. 30+31+32+33+34)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'33',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Capital subscris vărsat (ct. 1012)',
            searchText:'1. Capital subscris vărsat (ct. 1012)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'34',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Capital subscris nevărsat (ct. 1011)',
            searchText:'2. Capital subscris nevărsat (ct. 1011)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'35',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3. Patrimoniul regiei (ct. 1015)',
            searchText:'3. Patrimoniul regiei (ct. 1015)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'36',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'4. Patrimoniul institutelor naţionale de cercetare-dezvoltare (ct. 1018)',
            searchText:'4. Patrimoniul institutelor naţionale de cercetare-dezvoltare (ct. 1018)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'37',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'5. Alte elemente de capitaluri proprii (ct. 1031)',
            searchText:'5. Alte elemente de capitaluri proprii (ct. 1031)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'38',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'II. PRIME DE CAPITAL (ct. 104)',
            searchText:'II. PRIME DE CAPITAL (ct. 104)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'39',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'III. REZERVE DIN REEVALUARE (ct. 105)',
            searchText:'III. REZERVE DIN REEVALUARE (ct. 105)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'40',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'IV. REZERVE (ct.106)',
            searchText:'IV. REZERVE (ct.106)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'41',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Acţiuni proprii (ct. 109)',
            searchText:'Acţiuni proprii (ct. 109)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'42',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Câştiguri legate de instrumentele de capitaluri proprii (ct. 141)',
            searchText:'Câştiguri legate de instrumentele de capitaluri proprii (ct. 141)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'43',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Pierderi legate de instrumentele  de capitaluri proprii (ct. 149)',
            searchText:'Pierderi legate de instrumentele  de capitaluri proprii (ct. 149)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'44',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'V. PROFITUL SAU PIERDEREA REPORTAT(Ă)                   SOLD C (ct. 117)',
            searchText:'V. PROFITUL SAU PIERDEREA REPORTAT(Ă)                   SOLD C (ct. 117)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'45',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'SOLD D (ct. 117',
            searchText:'SOLD D (ct. 117',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'46',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VI. PROFITUL SAU PIERDEREA EXERCIŢIULUI FINANCIAR',
            searchText:'VI. PROFITUL SAU PIERDEREA EXERCIŢIULUI FINANCIAR',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'47',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'SOLD C (ct. 121)',
            searchText:'SOLD C (ct. 121)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'48',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'SOLD D (ct. 121)',
            searchText:'SOLD D (ct. 121)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'49',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Repartizarea profitului (ct. 129)',
            searchText:'Repartizarea profitului (ct. 129)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'50',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CAPITALURI PROPRII - TOTAL (rd. 29+35+36+37-38+39-40+41-42+43-44-45)',
            searchText:'CAPITALURI PROPRII - TOTAL (rd. 29+35+36+37-38+39-40+41-42+43-44-45)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'51',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Patrimoniul public (ct. 1016)',
            searchText:'Patrimoniul public (ct. 1016)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'52',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Patrimoniul privat (ct. 1017)',
            searchText:'Patrimoniul privat (ct. 1017)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'53',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CAPITALURI - TOTAL (rd. 46+47+48) (rd.04+09+10-13-16-17-18)',
            searchText:'CAPITALURI - TOTAL (rd. 46+47+48) (rd.04+09+10-13-16-17-18)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'54',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Cifra de afaceri netă (ct.701 + 702 + 703 + 704 + 705 + 706 + 708 + 707 - 709 + 741** + 766***)',
            searchText:'1. Cifra de afaceri netă (ct.701 + 702 + 703 + 704 + 705 + 706 + 708 + 707 - 709 + 741** + 766***)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'55',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Alte venituri (ct.711 + 712 + 721 + 722 + 725 + 741**** + 751 + 755 + 758 + 761 + 762 + 764 + 765 + 766 + 767 + 768 + 7815)',
            searchText:'2. Alte venituri (ct.711 + 712 + 721 + 722 + 725 + 741**** + 751 + 755 + 758 + 761 + 762 + 764 + 765 + 766 + 767 + 768 + 7815)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'56',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3. Costul materiilor prime și al consumabilelor (ct. 601 + 602 - 609*)',
            searchText:'3. Costul materiilor prime și al consumabilelor (ct. 601 + 602 - 609*)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'57',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'4. Cheltuieli cu personalul (ct. 641 + 642 + 643 + 644 + 645)',
            searchText:'4. Cheltuieli cu personalul (ct. 641 + 642 + 643 + 644 + 645)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'58',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'5. Ajustări de valoare (ct. 654 + 681 + 686 - 754 - 7812 - 7813 - 7814 - 786)',
            searchText:'5. Ajustări de valoare (ct. 654 + 681 + 686 - 754 - 7812 - 7813 - 7814 - 786)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'59',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'6. Alte cheltuieli*****  (ct. 603 + 604 + 605 + 606 + 607 + 608 - 609* + 611 + 612 + 613 + 614 + 615 + 621 + 622 + 623 + 624 + 625 + 626 + 627 + 628 + 635 + 651 + 652+ 655+ 658 + 663 + 664 + 665 + 667 + 666+ 668)',
            searchText:'6. Alte cheltuieli*****  (ct. 603 + 604 + 605 + 606 + 607 + 608 - 609* + 611 + 612 + 613 + 614 + 615 + 621 + 622 + 623 + 624 + 625 + 626 + 627 + 628 + 635 + 651 + 652+ 655+ 658 + 663 + 664 + 665 + 667 + 666+ 668)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'60',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'7. Impozite (ct.691 + 698)',
            searchText:'7. Impozite (ct.691 + 698)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'61',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'8.  PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            searchText:'8.  PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'62',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd.01+02-03-04-05-06-07)',
            searchText:'- Profit (rd.01+02-03-04-05-06-07)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'63',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd.03+04+05+06+07-01-02)',
            searchText:'- Pierdere (rd.03+04+05+06+07-01-02)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'64',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe comerciale, avansuri pentru cumpărări de bunuri de natura stocurilor și pentru prestări de servicii acordate furnizorilor şi alte conturi asimilate, în sume brute (ct. 4091 + 4092 + 411 + 413 + 418), din care:',
            searchText:'Creanţe comerciale, avansuri pentru cumpărări de bunuri de natura stocurilor și pentru prestări de servicii acordate furnizorilor şi alte conturi asimilate, în sume brute (ct. 4091 + 4092 + 411 + 413 + 418), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'65',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe neîncasate la termenul stabilit (din ct. 4091 + din ct. 4092 + din ct. 411 + din ct. 413)',
            searchText:'Creanţe neîncasate la termenul stabilit (din ct. 4091 + din ct. 4092 + din ct. 411 + din ct. 413)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'66',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe în legătură cu personalul şi conturi asimilate (ct. 425 + 4282)',
            searchText:'Creanţe în legătură cu personalul şi conturi asimilate (ct. 425 + 4282)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'67',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creanţe în legătură cu bugetul asigurărilor sociale şi bugetul statului (din ct. 431 + 437 + 4382 + 441 + 4424 + 4428 + 444 + 445 + 446 + 447 + 4482) , (rd.92 la 96)',
            searchText:'Creanţe în legătură cu bugetul asigurărilor sociale şi bugetul statului (din ct. 431 + 437 + 4382 + 441 + 4424 + 4428 + 444 + 445 + 446 + 447 + 4482) , (rd.92 la 96)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'68',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- creante in legatura cu bugetul asigurarilor sociale (ct.431+437+4382)',
            searchText:'- creante in legatura cu bugetul asigurarilor sociale (ct.431+437+4382)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'69',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- creante fiscale in legatura cu bugetul statului (ct.441+4424+4428+444+446)',
            searchText:'- creante fiscale in legatura cu bugetul statului (ct.441+4424+4428+444+446)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'70',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- subventii de incasat(ct.445)',
            searchText:'- subventii de incasat(ct.445)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'71',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            searchText:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'72',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- alte creante in legatura cu bugetul statului(ct.4482)',
            searchText:'- alte creante in legatura cu bugetul statului(ct.4482)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'73',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Creantele entitatii in relatiile cu entitatile afiliate(ct.451)',
            searchText:'Creantele entitatii in relatiile cu entitatile afiliate(ct.451)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'74',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Casa în lei şi în valută (rd.116+117 )',
            searchText:'Casa în lei şi în valută (rd.116+117 )',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'75',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei (ct. 5311)',
            searchText:'- în lei (ct. 5311)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'76',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută (ct. 5314)',
            searchText:'- în valută (ct. 5314)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'77',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Conturi curente la bănci în lei şi în valută (rd.119+121)',
            searchText:'Conturi curente la bănci în lei şi în valută (rd.119+121)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'78',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei (ct. 5121), din care:',
            searchText:'- în lei (ct. 5121), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'79',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- conturi curente în lei deschise la bănci nerezidente',
            searchText:'- conturi curente în lei deschise la bănci nerezidente',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'80',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută (ct. 5124), din care:',
            searchText:'- în valută (ct. 5124), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'81',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- conturi curente în valută deschise la bănci nerezidente',
            searchText:'- conturi curente în valută deschise la bănci nerezidente',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'82',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte conturi curente la bănci şi acreditive, (rd.124+125)',
            searchText:'Alte conturi curente la bănci şi acreditive, (rd.124+125)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'83',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume în curs de decontare, acreditive şi alte valori de încasat, în lei (ct. 5112 + 5125 + 5411)',
            searchText:'- sume în curs de decontare, acreditive şi alte valori de încasat, în lei (ct. 5112 + 5125 + 5411)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'84',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume în curs de decontare şi acreditive în valută (din ct. 5125 + 5414)',
            searchText:'- sume în curs de decontare şi acreditive în valută (din ct. 5125 + 5414)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'85',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii (rd. 127 + 130+ 133 + 136 + 139 + 142 + 145 + 148 + 151+ 154 + 157 + 158 + 161 + 162+ 164 + 165 + 170 + 171 + 172 + 178)',
            searchText:'Datorii (rd. 127 + 130+ 133 + 136 + 139 + 142 + 145 + 148 + 151+ 154 + 157 + 158 + 161 + 162+ 164 + 165 + 170 + 171 + 172 + 178)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'86',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Împrumuturi din emisiuni de obligaţiuni , în sume brute (ct. 161 ),(rd. 128 +129)',
            searchText:'Împrumuturi din emisiuni de obligaţiuni , în sume brute (ct. 161 ),(rd. 128 +129)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'87',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'88',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'89',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente imprumuturilor din emisiuni de obligatiuni in sume brute (ct.1681), (rd.131 +132)',
            searchText:'Dobanzi aferente imprumuturilor din emisiuni de obligatiuni in sume brute (ct.1681), (rd.131 +132)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'90',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'91',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in valuta',
            searchText:'- in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'92',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite bancare interne pe termen scurt  (ct. 5191 + 5192 + 5196 + 5197 ), (rd. 134+135)',
            searchText:'Credite bancare interne pe termen scurt  (ct. 5191 + 5192 + 5196 + 5197 ), (rd. 134+135)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'93',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'94',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'95',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzile aferente creditelor bancare interne pe termen scurt(din ct. 5198), (rd. 137+138)',
            searchText:'Dobanzile aferente creditelor bancare interne pe termen scurt(din ct. 5198), (rd. 137+138)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'96',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'97',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'98',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente creditelor bancare externe pe termen scurt (din ct.5198), ( rd. 143+144)',
            searchText:'Dobanzi aferente creditelor bancare externe pe termen scurt (din ct.5198), ( rd. 143+144)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'99',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'100',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in valuta',
            searchText:'- in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'101',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite bancare pe termen lung  (ct. 1621 + 1622 + 1627 ), (rd.146+147)',
            searchText:'Credite bancare pe termen lung  (ct. 1621 + 1622 + 1627 ), (rd.146+147)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'102',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'103',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'104',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente creditelor bancare pe termen lung (din ct.1682) (rd.149+150)',
            searchText:'Dobanzi aferente creditelor bancare pe termen lung (din ct.1682) (rd.149+150)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'105',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'106',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'-in valuta',
            searchText:'-in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'107',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite bancare externe pe termen lung  (ct. 1623 + 1624 + 1625 ) (rd.152+153)',
            searchText:'Credite bancare externe pe termen lung  (ct. 1623 + 1624 + 1625 ) (rd.152+153)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'108',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei',
            searchText:'- în lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'109',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'110',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Dobanzi aferente creditelor bancare externe pe termen lung ( din ct.1682), (rd. 155+156)',
            searchText:'Dobanzi aferente creditelor bancare externe pe termen lung ( din ct.1682), (rd. 155+156)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'111',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in lei',
            searchText:'- in lei',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'112',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- in valuta',
            searchText:'- in valuta',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'113',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Credite de la trezoreria statului si dobanzile aferente (ct.1626 + din ct. 1682)',
            searchText:'Credite de la trezoreria statului si dobanzile aferente (ct.1626 + din ct. 1682)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'114',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte împrumuturi şi dobânzile aferente (ct. 166  + 1685 + 1686 + 1687) (rd. 159+160)',
            searchText:'Alte împrumuturi şi dobânzile aferente (ct. 166  + 1685 + 1686 + 1687) (rd. 159+160)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'115',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în lei si exprimate in lei, a caror decontare se face in functie de cursul  unei valute',
            searchText:'- în lei si exprimate in lei, a caror decontare se face in functie de cursul  unei valute',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'116',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- în valută',
            searchText:'- în valută',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'117',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte împrumuturi şi datorii asimilate (ct. 167), din care:',
            searchText:'Alte împrumuturi şi datorii asimilate (ct. 167), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'118',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- valoarea concesiunilor primite (din ct. 167)',
            searchText:'- valoarea concesiunilor primite (din ct. 167)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'119',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii comerciale, avansuri primite de la clienţi şi alte conturi asimilate, în sume brute (ct. 401 + 403 + 404 + 405 + 408 + 419), din care:',
            searchText:'Datorii comerciale, avansuri primite de la clienţi şi alte conturi asimilate, în sume brute (ct. 401 + 403 + 404 + 405 + 408 + 419), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'120',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii în legătură cu personalul şi conturi asimilate (ct. 421 + 423 + 424 + 426 + 427 + 4281)',
            searchText:'Datorii în legătură cu personalul şi conturi asimilate (ct. 421 + 423 + 424 + 426 + 427 + 4281)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'121',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datorii în legătură cu bugetul asigurărilor sociale şi bugetul statului (ct. 431 + 437 + 4381 + 441 + 4423 + 4428 + 444 + 446 + 447 + 4481) (rd.166 la 169)',
            searchText:'Datorii în legătură cu bugetul asigurărilor sociale şi bugetul statului (ct. 431 + 437 + 4381 + 441 + 4423 + 4428 + 444 + 446 + 447 + 4481) (rd.166 la 169)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'122',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- datorii in legatura cu bugetul asigurarilor sociale (ct.431+437+4381)',
            searchText:'- datorii in legatura cu bugetul asigurarilor sociale (ct.431+437+4381)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'123',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- datorii fiscale in legatura cu bugetul statului (ct.441+4423+4428+444+446)',
            searchText:'- datorii fiscale in legatura cu bugetul statului (ct.441+4423+4428+444+446)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'124',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            searchText:'- fonduri speciale - taxe si varsaminte asimilate (ct.447)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'125',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- alte datorii in legatura cu bugetul statului (ct.4481)',
            searchText:'- alte datorii in legatura cu bugetul statului (ct.4481)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'126',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Datoriile entitatii in relatiile cu entitatile afiliate (ct.451)',
            searchText:'Datoriile entitatii in relatiile cu entitatile afiliate (ct.451)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'127',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sume datorate actionarilor / asociatilor (ct.455), din care:',
            searchText:'Sume datorate actionarilor / asociatilor (ct.455), din care:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'128',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume datorate actionarilor / asociatilor PF',
            searchText:'- sume datorate actionarilor / asociatilor PF',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'129',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- sume datorate actionarilor / asociatilor PJ',
            searchText:'- sume datorate actionarilor / asociatilor PJ',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'130',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte datorii (ct. 269 + 453 + 456 + 457 + 4581 + 4661 + 462 + 472 + 473 + 478 + 509)   (rd.173 la 177)',
            searchText:'Alte datorii (ct. 269 + 453 + 456 + 457 + 4581 + 4661 + 462 + 472 + 473 + 478 + 509)   (rd.173 la 177)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'131',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'1. Cifra de afaceri netă (rd. 222+223-224+225+226)',
            searchText:'1. Cifra de afaceri netă (rd. 222+223-224+225+226)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'132',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Producţia  vândută  (ct.701+702+703+704+705+706+708)',
            searchText:'Producţia  vândută  (ct.701+702+703+704+705+706+708)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'133',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Venituri din vânzarea mărfurilor (ct. 707)',
            searchText:'Venituri din vânzarea mărfurilor (ct. 707)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'134',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Reduceri comerciale acordate (ct. 709)',
            searchText:'Reduceri comerciale acordate (ct. 709)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'135',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Venituri din dobânzi înregistrate de entităţile radiate din Registrul general si care mai au in derulare contracte de leasing  (ct.766) 7)',
            searchText:'Venituri din dobânzi înregistrate de entităţile radiate din Registrul general si care mai au in derulare contracte de leasing  (ct.766) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'136',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Venituri din subvenţii de exploatare aferente cifrei de afaceri nete (ct.7411)',
            searchText:'Venituri din subvenţii de exploatare aferente cifrei de afaceri nete (ct.7411)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'137',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'2. Venituri aferente costului producţiei în curs de execuţie  (ct.711+712)',
            searchText:'2. Venituri aferente costului producţiei în curs de execuţie  (ct.711+712)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'138',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sold C',
            searchText:'Sold C',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'139',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Sold D',
            searchText:'Sold D',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'140',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'3.  Venituri din producţia de imobilizari necorporale si corporale (ct.721+ 722)',
            searchText:'3.  Venituri din producţia de imobilizari necorporale si corporale (ct.721+ 722)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'141',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'4. Venituri din reevaluarea imobilizărilor corporale (ct. 755)',
            searchText:'4. Venituri din reevaluarea imobilizărilor corporale (ct. 755)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'142',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'5. Venituri din producţia de investiţii imobiliare  (ct. 725)',
            searchText:'5. Venituri din producţia de investiţii imobiliare  (ct. 725)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'143',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'6. Venituri din subvenții de exploatare (ct. 7412 + 7413 + 7414 + 7415 + 7416 + 7417 + 7419)',
            searchText:'6. Venituri din subvenții de exploatare (ct. 7412 + 7413 + 7414 + 7415 + 7416 + 7417 + 7419)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'144',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'7. Alte venituri din exploatare (ct.751+758+7815)',
            searchText:'7. Alte venituri din exploatare (ct.751+758+7815)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'145',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'-din care, venituri din fondul comercial negativ  (ct.7815)',
            searchText:'-din care, venituri din fondul comercial negativ  (ct.7815)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'146',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'-din care, venituri din subvenții pentru investiții (ct. 7584)',
            searchText:'-din care, venituri din subvenții pentru investiții (ct. 7584)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'147',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VENITURI DIN EXPLOATARE – TOTAL (rd. 221 + 227 - 228 + 229 + 230 + 231 + 232 + 233)',
            searchText:'VENITURI DIN EXPLOATARE – TOTAL (rd. 221 + 227 - 228 + 229 + 230 + 231 + 232 + 233)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'148',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'8. a)  Cheltuieli cu materiile prime şi materialele consumabile (ct.601+602)',
            searchText:'8. a)  Cheltuieli cu materiile prime şi materialele consumabile (ct.601+602)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'149',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte cheltuieli materiale (ct.603+604+606+608)',
            searchText:'Alte cheltuieli materiale (ct.603+604+606+608)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'150',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b) Alte cheltuieli externe (cu energie şi apă)(ct.605)',
            searchText:'b) Alte cheltuieli externe (cu energie şi apă)(ct.605)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'151',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'c) Cheltuieli privind mărfurile (ct.607)',
            searchText:'c) Cheltuieli privind mărfurile (ct.607)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'152',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Reduceri comerciale primite (ct. 609)',
            searchText:'Reduceri comerciale primite (ct. 609)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'153',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'9. Cheltuieli cu personalul (rd. 243 + 244)',
            searchText:'9. Cheltuieli cu personalul (rd. 243 + 244)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'154',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'a) Salarii şi indemnizaţii 8) (ct.641+642+643+644)',
            searchText:'a) Salarii şi indemnizaţii 8) (ct.641+642+643+644)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'155',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b) Cheltuieli privind asigurările şi protecţia socială (ct.645)',
            searchText:'b) Cheltuieli privind asigurările şi protecţia socială (ct.645)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'156',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'10.a) Ajustări de valoare privind imobilizările corporale şi necorporale (rd. 246 - 247)',
            searchText:'10.a) Ajustări de valoare privind imobilizările corporale şi necorporale (rd. 246 - 247)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'157',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'a.1) Cheltuiel (ct.6811+6813+6817)',
            searchText:'a.1) Cheltuiel (ct.6811+6813+6817)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'158',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'a.2) Venituri (ct.7813)',
            searchText:'a.2) Venituri (ct.7813)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'159',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b) Ajustări de valoare privind activele circulante (rd. 249 - 250)',
            searchText:'b) Ajustări de valoare privind activele circulante (rd. 249 - 250)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'160',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b.1) Cheltuieli (ct.654+6814)',
            searchText:'b.1) Cheltuieli (ct.654+6814)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'161',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'b.2) Venituri (ct.754+7814)',
            searchText:'b.2) Venituri (ct.754+7814)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'162',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11. Alte cheltuieli de exploatare (rd. 252 la 258)',
            searchText:'11. Alte cheltuieli de exploatare (rd. 252 la 258)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'163',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.1. Cheltuieli privind prestaţiile externe (ct.611+612+613+614+615+621+622+623+624+625+626+627+628)',
            searchText:'11.1. Cheltuieli privind prestaţiile externe (ct.611+612+613+614+615+621+622+623+624+625+626+627+628)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'164',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.2. Cheltuieli cu alte impozite, taxe şi vărsăminte asimilate;  cheltuieli reprezentând transferuri şi contribuţii datorate în baza unor acte normative speciale (ct. 635 + 6586 9) )',
            searchText:'11.2. Cheltuieli cu alte impozite, taxe şi vărsăminte asimilate;  cheltuieli reprezentând transferuri şi contribuţii datorate în baza unor acte normative speciale (ct. 635 + 6586 9) )',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'165',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.3. Cheltuieli cu protecţia mediului înconjurător (ct. 652)',
            searchText:'11.3. Cheltuieli cu protecţia mediului înconjurător (ct. 652)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'166',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.4 Cheltuieli din reevaluarea imobilizărilor corporale (ct. 655)',
            searchText:'11.4 Cheltuieli din reevaluarea imobilizărilor corporale (ct. 655)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'167',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.5. Cheltuieli privind calamităţile şi alte evenimente similare (ct. 6587)',
            searchText:'11.5. Cheltuieli privind calamităţile şi alte evenimente similare (ct. 6587)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'168',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'11.6. Alte cheltuieli (ct. 651 + 6581 + 6582 + 6583 + 6588)',
            searchText:'11.6. Alte cheltuieli (ct. 651 + 6581 + 6582 + 6583 + 6588)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'169',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Cheltuieli cu dobânzile de refinanţare înregistrate de entităţile radiate din Registrul general şi care mai au în derulare contracte de leasing (ct. 666) 7)',
            searchText:'Cheltuieli cu dobânzile de refinanţare înregistrate de entităţile radiate din Registrul general şi care mai au în derulare contracte de leasing (ct. 666) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'170',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Ajustări privind provizioanele (rd. 260 - 261)',
            searchText:'Ajustări privind provizioanele (rd. 260 - 261)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'171',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Cheltuieli (ct.6812)',
            searchText:'- Cheltuieli (ct.6812)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'172',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Venituri (ct.7812)',
            searchText:'- Venituri (ct.7812)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'173',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CHELTUIELI DE EXPLOATARE – TOTAL(rd. 237 la 240 - 241 + 242 + 245 + 248 + 251 + 259)',
            searchText:'CHELTUIELI DE EXPLOATARE – TOTAL(rd. 237 la 240 - 241 + 242 + 245 + 248 + 251 + 259)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


        {
            jsId:'174',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'PROFITUL SAU PIERDEREA DIN EXPLOATARE:',
            searchText:'PROFITUL SAU PIERDEREA DIN EXPLOATARE:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'175',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 236 - 262)',
            searchText:'- Profit (rd. 236 - 262)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'176',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 262 - 236)',
            searchText:'- Pierdere (rd. 262 - 236)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'177',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'12.  Venituri din interese de participare (ct.7611+7612+7613)',
            searchText:'12.  Venituri din interese de participare (ct.7611+7612+7613)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },
        
        {
            jsId:'178',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, veniturile obţinute de la entităţile afiliate',
            searchText:'- din care, veniturile obţinute de la entităţile afiliate',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'179',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'13.  Venituri din dobânzi (ct.766) 7)',
            searchText:'13.  Venituri din dobânzi (ct.766) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'180',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, veniturile obţinute de la entităţile afiliate',
            searchText:'- din care, veniturile obţinute de la entităţile afiliate',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'181',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'14. Venituri din subvenţii de exploatare pentru dobânda datorată  (ct. 7418)',
            searchText:'14. Venituri din subvenţii de exploatare pentru dobânda datorată  (ct. 7418)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'182',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'15. Alte venituri financiare (ct. 7615 + 762 + 764 + 765 + 767 + 768)',
            searchText:'15. Alte venituri financiare (ct. 7615 + 762 + 764 + 765 + 767 + 768)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'183',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, venituri din alte imobilizări financiare    (ct. 7615)',
            searchText:'- din care, venituri din alte imobilizări financiare    (ct. 7615)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'184',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VENITURI FINANCIARE – TOTAL (rd. 265 + 267 + 269 + 270)',
            searchText:'VENITURI FINANCIARE – TOTAL (rd. 265 + 267 + 269 + 270)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'185',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'16.  Ajustări de valoare privind imobilizările financiare şi investiţiile financiare deţinute ca active circulante (rd. 274 - 275)',
            searchText:'16.  Ajustări de valoare privind imobilizările financiare şi investiţiile financiare deţinute ca active circulante (rd. 274 - 275)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'186',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Cheltuieli  (ct.686)',
            searchText:'- Cheltuieli  (ct.686)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'187',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Venituri (ct.786)',
            searchText:'- Venituri (ct.786)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'188',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'17.  Cheltuieli privind dobânzile (ct.666) 7)',
            searchText:'17.  Cheltuieli privind dobânzile (ct.666) 7)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'189',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- din care, cheltuielile în relaţia cu entităţile afiliate',
            searchText:'- din care, cheltuielile în relaţia cu entităţile afiliate',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'190',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'Alte cheltuieli financiare (ct.663+664+665+667+668)',
            searchText:'Alte cheltuieli financiare (ct.663+664+665+667+668)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'191',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CHELTUIELI FINANCIARE – TOTAL (rd. 273+ 276 +278)',
            searchText:'CHELTUIELI FINANCIARE – TOTAL (rd. 273+ 276 +278)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'192',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'PROFITUL SAU PIERDEREA FINANCIAR(Ă):',
            searchText:'PROFITUL SAU PIERDEREA FINANCIAR(Ă):',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'193',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 272 - 279)',
            searchText:'- Profit (rd. 272 - 279)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'194',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 279 - 272)',
            searchText:'- Pierdere (rd. 279 - 272)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'195',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'VENITURI TOTALE (rd. 236 + 272)',
            searchText:'VENITURI TOTALE (rd. 236 + 272)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'196',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'CHELTUIELI TOTALE (rd. 262 + 279)',
            searchText:'CHELTUIELI TOTALE (rd. 262 + 279)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'197',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'18. PROFITUL SAU PIERDEREA BRUT(Ă):',
            searchText:'18. PROFITUL SAU PIERDEREA BRUT(Ă):',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'198',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 282 - 283)',
            searchText:'- Profit (rd. 282 - 283)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'199',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 283 - 282)',
            searchText:'- Pierdere (rd. 283 - 282)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'200',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'19.  Impozitul pe profit (ct. 691)',
            searchText:'19.  Impozitul pe profit (ct. 691)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'201',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'20.  Alte impozite neprezentate la elementele de mai sus (ct. 698)',
            searchText:'20.  Alte impozite neprezentate la elementele de mai sus (ct. 698)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'202',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'21. PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            searchText:'21. PROFITUL SAU PIERDEREA NET(Ă) A EXERCIŢIULUI FINANCIAR:',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'203',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Profit (rd. 284 - 285 - 286 - 287)',
            searchText:'- Profit (rd. 284 - 285 - 286 - 287)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },

        {
            jsId:'204',
            capitol:'',
            subcapitol:'',
            nrRdBilant:'',
            name:'',
            displayName:'', 
            bilantDescription:'- Pierdere (rd. 285 + 286 + 287 - 284)',
            searchText:'- Pierdere (rd. 285 + 286 + 287 - 284)',
            soldInitial:0,
            soldFinal:0,
            showInWizard:true
        
        },


    ]

    
}